import React from 'react';
import classNames from 'classnames/bind';
import { Growth } from "../../../../icons";
import styles from './NewWindowIcon.css';
var cx = classNames.bind(styles);
export var NewWindowIcon = function NewWindowIcon() {
  return /*#__PURE__*/React.createElement("span", {
    className: cx('root')
  }, /*#__PURE__*/React.createElement(Growth, {
    width: 12
  }));
};